/**
 * Merges current location state with new state
 * Useful for preserving navigation context when navigating
 */
export function mergeLocationState<T extends Record<string, any>>(
  currentState: unknown,
  newState: T
): T {
  const current = (currentState as Record<string, any>) || {};
  return { ...current, ...newState };
}

